import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared-service/services/user.service';
import { Title, Meta } from '@angular/platform-browser';
import { MetaService } from '../shared-service/services/meta-service.service';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from '../app.config';

@Component({
  selector: 'app-shipping',
  templateUrl: './shipping.component.html',
  styleUrls: ['./shipping.component.css']
})
export class ShippingComponent implements OnInit {

  banner:any;
  featured_image:any;
  title = 'Shipping';
  description:any;
  isloader:boolean = true;
  url = '';
  urlPath = '';
  todayDate = new Date();
  logo='';
  imgWidth='';
  imgHeight='';

  constructor(
    private titleService: Title,
    private userService: UserService,
    private metaService: Meta,
    private route: ActivatedRoute,
    private metaServiceCustom: MetaService,
    private config: AppConfig
  ) {
    this.imgWidth = this.config.getConfig('LOGO_WIDTH');
    this.imgHeight = this.config.getConfig('LOGO_HEIGHT');
    this.logo = this.config.getConfig('LOGO1');
   }

  ngOnInit() {
    if(this.route.snapshot && this.route.snapshot['_urlSegment'] && this.route.snapshot['_urlSegment']['segments'] && this.route.snapshot['_urlSegment']['segments'].length > 0) {
      this.route.snapshot['_urlSegment']['segments'].forEach(item => {
        this.urlPath = this.urlPath + item.path + '/';
      });
    }
    if(this.urlPath && this.urlPath.length > 0) {
      this.urlPath = this.urlPath.substring(0, this.urlPath.length-1);
    }
    this.getPageInitData(this.urlPath);
    this.getPageData('shipping');
  }

  getPageInitData(url) {
    this.userService.getPageInitData(url).subscribe((res:any) => {
      if(res.data && res.data.seo_tags[0] && res.data.seo_tags[0]['redirection_url']) {
        window.location.href = res.data.seo_tags[0]['redirection_url'];
      }
      if(res.data.seo_tags[0]) {
        this.titleService.setTitle(res.data.seo_tags[0]['page_tittle']);
        let indexCust = res.data.seo_tags[0]['no_index'] == '0' ? 'INDEX' : 'NO INDEX';
        let followCust = res.data.seo_tags[0]['no_follow'] == '0' ? 'FOLLOW' : 'NO FOLLOW';
        let custContent = indexCust + ',' + followCust;
        this.metaService.updateTag( { name:'description', content: res.data.seo_tags[0]['description']},"name='description'");
        this.metaService.updateTag( { name:'robots', content: custContent},"name='robots'");
        // this.metaService.addTags([
        //   {name: 'description', content: res.data.seo_tags[0]['description']},
        //   {name: 'robots', content: custContent}
        // ]);
      }

      this.metaServiceCustom.createCanonicalURL();
    });
  }

  getPageData(page){
    this.userService.getPageData(page).subscribe(
      (res: any) =>{
        if(res.state === 200){
          this.banner = res.data.banner;
          this.featured_image = res.data.featured_image;
          this.title = res.data.page_title;
          this.description = res.data.page_description;


          // this.titleService.setTitle(this.titleName+' | '+res.data.meta_title);
          // this.metaService.addTags([
          //   {name: 'keywords', content: res.data.meta_keyword},
          //   {name: 'description', content: res.data.meta_description},
          //   {name: 'robots', content: 'index, follow'}
          // ]);

          this.isloader = true;
        }
      }
    );
  }

}